import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { ClipLoader } from "react-spinners";
import VoaFilter from "./voa_item_modal/voa_filter.component";
import { connect } from "react-redux";
import * as voa from "~/voa/redux";
import { service } from "../redux";
import swal from "sweetalert";

class VoaItemsModal extends React.Component {
    filterRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    render() {
        const { className, buttonLabel } = this.props;
        const { modal } = this.state;
        const modalStyle = { width: "80%", maxWidth: "80%" };
        return (
            <React.Fragment>
                {buttonLabel && (
                    <Button color="primary" onClick={this.toggle}>
                        {buttonLabel}
                    </Button>
                )}
                <Modal isOpen={modal} toggle={this.toggle} className={className} backdrop="static" style={modalStyle}>
                    <ModalHeader toggle={this.toggle}>Voa Items</ModalHeader>
                    <ModalBody>
                        <VoaFilter ref={this.filterRef} onSubmit={this.onFilter} run={this.props.run} />
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoading && (
                            <div className="float-right">
                                <ClipLoader />
                            </div>
                        )}
                        <Button disabled={this.state.isLoading} color="danger" onClick={this.toggle}>
                            Cancel
                        </Button>
                        <Button icon="save" color="primary" onClick={this.onSave}>
                            Save
                        </Button>
                        {/*{this.props.onSend && this.state.withOnSend && this.state.nextStep && (*/}
                        {/*    <Button*/}
                        {/*        disabled={this.state.isLoading}*/}
                        {/*        icon="paper-plane"*/}
                        {/*        color="success"*/}
                        {/*        onClick={_ => this.send()}*/}
                        {/*    >*/}
                        {/*        {nextStep.display}*/}
                        {/*    </Button>*/}
                        {/*)}*/}
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }

    onFilter = filters => {
        this.props.changeFilters(filters);
    };

    onSave = () => {
        const { values } = this.filterRef.current;
        if (values.items.length > 0) {
            service
                .syncVoaNonSode(this.props.run, values.items)
                .then(res => {
                    this.props.updatePage();
                    this.toggle();
                })
                .catch(error => {
                    if (error && error.response && error.response.status === 400) {
                        swal({
                            title: "Warning!",
                            text: error.response.data.detail,
                            icon: "warning",
                            timer: 3000,
                            button: true
                        });
                    }
                });
        }
    };
}
const mapStateToProps = store => ({
    voas: store.voa.list,
    loading: store.voa.loading,
    loaded: store.voa.loaded,
    pagination: store.voa.pagination
});

const mapDispatchToProps = dispatch => ({
    getVoas: () => dispatch(voa.actions.getVoas()),
    changePage: page => dispatch(voa.actions.changePage(page)),
    changeFilters: filters => dispatch(voa.actions.updateFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(VoaItemsModal);
